import { gql } from '@apollo/client';

export const GET_ALL_TV_APP_CONFIGURATIONS_QUERY = gql`
  fragment TVAppConfigurationFields on TvAppConfiguration {
    id
    name
    slug
    order
    screens
    stayInformations {
      id
      title
      locale
      localizations {
        id
        locale
        title
      }
    }
    surroundingInformationCategories {
      id
      title
      locale
      localizations {
        id
        locale
        title
      }
    }
  }

  query GetAllTvAppConfigurations($hotelId: ID!) {
    hotel(id: $hotelId) {
      id
      tvAppConfigurations(sort: "id:asc") {
        ...TVAppConfigurationFields
      }
    }
  }
`;
